// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"07a07b46","376":"f5545032","453":"2cd2c972","496":"da88ea8c","620":"5460c293","718":"e8e6aabc","977":"5e1ce9f5","996":"d8e2dd0a"}[chunkId] + ".chunk.js";
};